export default __webpack_public_path__ + "713909dd57696978abf66e8db5312203.png";